module.exports = __webpack_public_path__ + "static/media/JobPostsPort.b8fd0a40.png";